export default "__VITE_ASSET__DyfChjaf__"